<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex md12>
                <material-card>
                    <models-areaCarrerasSede-table :carrerasSede="carrerasSede"></models-areaCarrerasSede-table>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import Vue from "vue"
import { CarreraSedesService } from "../../services/carreras-api.service"

export default Vue.extend({
    data: () => ({
        carrerasSede: []
    }),
    methods: {
        fetchCarrerasSede() {
            CarreraSedesService.where({
                carreraSede: {
                    carreraId: this.$route.params.id
                },
                include: "[sede:universidad]"
            }).then(carrerasSede => {
                this.carrerasSede = carrerasSede
            })
        }
    },
    async created() {
        this.fetchCarrerasSede()
    }
})
</script>
